import React, { useRef, useEffect } from "react";
import "./animation3D.css";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry";

const Animation3D = () => {
  const mountRef = useRef(null);
  useEffect(() => {
    const mount = mountRef.current;
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      49,
      mount.clientWidth / mount.clientHeight,
      0.1,
      1000
    );
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(mount.clientWidth, mount.clientHeight);
    renderer.setClearColor(0x000000, 0); // Transparent background
    mount.appendChild(renderer.domElement);

    // Adjust these values to change the number of wireframes
    const widthSegments = 20; // Number of horizontal segments
    const heightSegments = 20; // Number of vertical segments

    const earth = new THREE.Mesh(
      new THREE.SphereGeometry(1, widthSegments, heightSegments),
      new THREE.MeshBasicMaterial({ color: 0xffffff, wireframe: true })
    );
    scene.add(earth);

    new FontLoader().load(
      "https://threejs.org/examples/fonts/helvetiker_regular.typeface.json",
      (font) => {
        // const text = new THREE.Mesh(
        //   new TextGeometry("MS Digital Media", {
        //     font,
        //     size: 0.2,
        //     height: 0.05,
        //   }),
        //   new THREE.MeshBasicMaterial({ color: 0xffffff })
        // );
        // text.position.set(-1, -1.5, 0);
        // scene.add(text);
      }
    );

    const controls = new OrbitControls(camera, renderer.domElement);
    camera.position.z = 3;

    const animate = () => {
      requestAnimationFrame(animate);
      earth.rotation.y += 0.001;
      controls.update();
      renderer.render(scene, camera);
    };
    animate();

    const handleResize = () => {
      camera.aspect = mount.clientWidth / mount.clientHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(mount.clientWidth, mount.clientHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      mount.removeChild(renderer.domElement);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return <div ref={mountRef} style={{ width: "100%", height: "100vh" }} />;
};

export default Animation3D;
